export default __webpack_public_path__ + "static/media/Hornchurch.206462a1.png";